import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Bookmark, Check, ArrowRight } from "lucide-react";
import { useInspiration } from "../hooks/useStore";

export default function DesignCard({ design, delay = 0, eager = false }) {
  const { list, dispatch } = useInspiration();
  const isSaved = list.some((i) => i.id === design.id);
  const [justSaved, setJustSaved] = useState(false);

  const handleSave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch({
      type: "TOGGLE",
      item: {
        id: design.id,
        slug: design.slug,
        name: design.name,
        category: design.category,
        image: design.image,
        finish: design.finishes?.[0] || "",
      },
    });
    if (!isSaved) {
      setJustSaved(true);
      setTimeout(() => setJustSaved(false), 1800);
    }
  };

  return (
    <Link
      to={`/portfolio/${design.slug}`}
      className="product-card group relative block"
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="relative overflow-hidden bg-cream-100 aspect-[4/5] rounded-sm">
        <img
          src={design.image}
          alt={`${design.name} — bespoke ${design.category.replace(/-/g, " ")} by Ananda Paudel, Nepal`}
          className="product-img w-full h-full object-cover transition-transform duration-700"
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          width="700"
          height="875"
        />

        <button
          onClick={handleSave}
          className={`absolute top-3 right-3 z-10 w-8 h-8 rounded-full flex items-center justify-center transition-all duration-300 ${
            isSaved || justSaved
              ? "bg-walnut-500 text-white"
              : "bg-white/90 text-matte-500 opacity-0 group-hover:opacity-100"
          }`}
          aria-label={isSaved ? "Remove from inspiration list" : "Save to inspiration list"}
          title={isSaved ? "Saved to your inspiration list" : "Save to your inspiration list"}
        >
          {justSaved ? <Check size={14} /> : <Bookmark size={14} fill={isSaved ? "currentColor" : "none"} />}
        </button>

        <div className="product-overlay absolute inset-0 bg-matte-900/40 flex flex-col items-center justify-end pb-5 gap-2 opacity-0 transition-opacity duration-300">
          <span className="w-4/5 text-center bg-white text-matte-900 font-sans text-xs tracking-widest uppercase px-4 py-2.5 flex items-center justify-center gap-2">
            View Design <ArrowRight size={12} />
          </span>
          <button
            onClick={handleSave}
            className={`w-4/5 text-center font-sans text-xs tracking-widest uppercase px-4 py-2.5 transition-colors duration-200 flex items-center justify-center gap-1.5 ${
              isSaved || justSaved
                ? "bg-walnut-500 text-white"
                : "bg-matte-900/80 text-cream-100 hover:bg-walnut-600"
            }`}
          >
            {justSaved ? <><Check size={12} /> Saved</> : isSaved ? <><Check size={12} /> Saved</> : <><Bookmark size={12} /> Save Design</>}
          </button>
        </div>
      </div>

      <div className="pt-4">
        <h3 className="font-serif text-base text-matte-900 leading-snug group-hover:text-walnut-600 transition-colors line-clamp-1">
          {design.name}
        </h3>
        <p className="font-sans text-xs text-matte-400 capitalize mt-0.5 mb-1.5">
          {design.category.replace(/-/g, " ")}
        </p>
        <p className="font-sans text-xs text-walnut-500 tracking-wide">
          Reference design · Bespoke build
        </p>
      </div>
    </Link>
  );
}
